module.exports = __webpack_public_path__ + "static/media/SALU_Logo.d9d41692.png";